module.exports = __webpack_public_path__ + "img/msp-pro.977e21c7.svg";